export const showPane = id => ({
  type: "SHOW_PANE",
  id
});
